function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../config';
import { breakpoint } from '../../theme';
const Wrapper = styled.div`
  display: block;
  margin: 0 auto;
  max-width: ${({
  fluid
}) => fluid ? '100% !important' : `${BREAKPOINTS.desktop.containerSize}`};
  padding: ${({
  fullBleed
}) => fullBleed ? '0 !important' : `0 ${BREAKPOINTS.mobile.margin}`} ;
  ${breakpoint.md`padding: 0 ${BREAKPOINTS.tablet.margin};`}
  ${breakpoint.lg`padding: 0 ${BREAKPOINTS.desktop.margin};`}
`;
export const Container = ({
  children,
  fluid = false,
  fullBleed = false,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  fluid,
  fullBleed
}, props), children);
export default Container;
//# sourceMappingURL=index.js.map